// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"64375609","667":"db6c1e4d","977":"42226ce0"}[chunkId] + ".chunk.js";
};